import React from 'react';

import FittingStatOverviewCountContainer from '../containers/FittingStatOverviewCountContainer.jsx';

export default class FittingDashboardComponent extends React.Component {

  componentDidMount() {
  }

  render() {
    return (
    <div>
      <br/>
      <h4>套量總數/已套量</h4>
      <FittingStatOverviewCountContainer orderId={this.props.orderId} />
      <br/>
      <h4>套量明細</h4>
      {this.props.statDetailDataListDisplay}
    </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/FittingDashboardComponent.jsx